import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class StripeBillingPortalSession extends BaseModel {
  url: string;

  constructor(model: Partial<StripeBillingPortalSession> = {}) {
    super();

    this.url = model.url!;
  }
}
